<template>
  <div id="service">
    <el-dialog
      width="480px"
      :title="form.title"
      :visible.sync="dialogFormVisible"
      class="dialog-class"
      :before-close="handleClose"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item
          prop="user_name"
          label="姓名"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入姓名"
            v-model="form.user_name"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="mobile"
          label="手机号"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入手机号"
            v-model="form.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item 
          prop="work_unit" 
          label="单位" 
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入单位"
            v-model="form.work_unit"
          ></el-input>
        </el-form-item>
        <el-form-item label="您的需求" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入"
            type="textarea"
            v-model="form.content"
          ></el-input>
        </el-form-item>

      </el-form>
      <!-- <div class="phone">
        <div class="kefu">
          <p>客服电话：</p>
          <p class="kefu-phone">0571 86711325</p>
        </div>
        <div class="wechat-big">
          <div class="wechat">
            <p>微信客服：</p>
            <p class="kefu-phone">社汇小秘书</p>
          </div>
          <div>
            <img class="erweima" src="../../static/img/erweima.jpg" alt="" />
          </div>
          <div></div>
        </div>
      </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button
          style="background: #35bdb2"
          type="primary"
          @click="sureClick('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      width="480px"
      :title="tipsType=='Tip'?'提示':'提交成功'"
      :visible.sync="dialogTipsVisible"
      class="dialog-class dialog-tishi-class"
    >
      <div class="code">
        <img :src="'https://dl.sosho.cn/goserver/tool/qrcode?content='+config.url" alt="">
      </div>
      <p style="margin-top:20px;">{{tipsType=='Tip'?'微信扫一扫即可联系社汇小助手':'微信扫一扫，关注 '+this.config.name+' 客服'}}</p>
      <!-- <p><a :href="this.config.url" download class="kefu-phone">下载二维码</a></p> -->
      <div slot="footer" class="dialog-footer">
        <el-button
          style="background: #35bdb2"
          type="primary"
          @click="dialogTipsVisible = false"
          >好的</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
// const host = "https://tapi.sosho.cn";
const host = "https://api.sosho.cn";
export default {
  components: {
  },
  data () {
    return {
        config: {
        },
        dialogFormVisible: false,
        dialogTipsVisible:false,
        dialogTableVisible: false,
        form: {
            user_name: "",
            mobile: "",
            content: "",
            title: "",
        },
        formLabelWidth: "120px",
        rules: {
            user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            mobile: [
            { required: true, message: "请输入联系电话", trigger: "blur" },
            ],
            work_unit:[
            { required: true, message: "请输入单位", trigger: "blur" },
            ],
        },
        tipsType:"Tip",
        server:'王先生',
    }
  },
  created(){
  },
  computed:{

  },
  mounted(){

  },
  methods: {
    cancel(){
        this.dialogFormVisible = false;
        this.tipsType='Tip';
        this.dialogTipsVisible=true;
        this.$nextTick(() => {
            this.creatQrCode();
        })
    },
    creatQrCode() {
        $('#qrCodeUrl').text('');
        var doms =  document.getElementById('qrCodeUrl');
        $.ajax({
            type: "GET",
            url: host + "/operate/wxwork_customer_service?appkey=h5",
            success: (dataIn) => {
                if(dataIn.items.length > 0){
                    this.config = dataIn.items[0];
                }
            }
        })
    },
    handleClose(done){
        this.dialogFormVisible = false;
        this.dialogTipsVisible=true;
        this.tipsType='Tip';
        this.$nextTick(() => {
            this.creatQrCode();
        })
    },
    xcxClick(title) {
        this.form = {
            user_name: "",
            mobile: "",
            content: "",
            title: "",
            work_unit:'',
        };
        this.form.title = title;
        this.dialogFormVisible = true;
        
    },
    sureClick(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          $.ajax({
            type: "POST",
            url: host + "/saas/consult",
            data: {
              user_name: this.form.user_name,
              mobile: this.form.mobile,
              content: this.form.content,
              work_unit:this.form.work_unit,
              product_name: this.form.title,
              com_name: this.form.work_unit || "社汇官网",
            },
            headers: {
              appkey: "pwsite",
            },
            success: (dataIn) => {
              this.tipsType='success';
              this.dialogFormVisible = false;
              this.dialogTipsVisible=true;
              // if(dataIn.errno == 0){
              //     this.$message({
              //         message: '短信验证码已发送，请注意接收',
              //         type: 'success'
              //     });
              //     this.centerDialogVisible = false;
              //     localStorage.setItem('getImgCodeTime', Date.now())
              // }else{
              //     this.$message.error(dataIn.errmsg);
              // }
            },
          });
        }
      });
    },
  },
}
</script>

<style lang="less"  scoped>
#service{
    width: 100%;
    height: 100%;
    .el-dialog__wrapper{
        background: rgba(0, 0, 0, 0.3);
        z-index: 9999!important;
    }
    /deep/ .el-dialog {
        border-radius: 4px !important;
        position: relative;
    }
    /deep/ .el-carousel__indicators {
        padding-bottom: 200px;
    }
    /deep/ .el-carousel__arrow--left {
        left: 220px;
        top: 305px;
    }
    /deep/ .el-carousel__arrow {
        width: 60px;
        height: 60px;
    }
    /deep/ .el-carousel__arrow i {
        font-size: 20px;
    }
    /deep/ .el-carousel__arrow--right {
        right: 220px;
        top: 305px;
    }
    /deep/ .el-button--primary {
        background-color: rgb(53, 189, 178);
        border-color: rgb(53, 189, 178);
    }
    /deep/ .el-button--default:hover {
        background-color: #fff;
        border-color: rgb(53, 189, 178);
        color: rgb(53, 189, 178);
    }

    .dialog-tishi-class /deep/ .el-dialog__body{
        padding: 0 20px !important;
    }
    .dialog-tishi-class{
        .code{
            width: 100%;
            height: 200px;
            display: flex;
            justify-content: space-around;
            img{
                width: 200px;
                height: 200px;
            }
        }
        p{
            text-align: center;
            margin-top: 10px;
        }
        a{
            color: #00bbad;
            text-decoration-line: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/v-servicechat.vue